import { render, staticRenderFns } from "./CardItem.vue?vue&type=template&id=3cfb3d18&scoped=true"
import script from "./CardItem.vue?vue&type=script&lang=js"
export * from "./CardItem.vue?vue&type=script&lang=js"
import style0 from "./CardItem.scss?vue&type=style&index=0&id=3cfb3d18&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cfb3d18",
  null
  
)

export default component.exports